import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-base',
  templateUrl: './table-base.component.html'
})
export class TableBaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
